<template>
  <div class="affiliation-container">
    <custom-skeleton-loader :LoadingFlag="SkeletonLoadingFlag" />
    <div v-if="!SkeletonLoadingFlag" class="affiliation-content">
      <!-- Status Section -->
      <div class="status-section">
        <div class="status-header">
          <div class="status-icon">
            <v-icon>mdi-file-check</v-icon>
          </div>
          <div class="status-info">
            <div class="status-label">LO Affiliation Status</div>
            <v-chip :color="getActiveStatusColor(AffiliationData.LomStatusTxt)" dark class="status-chip">
              {{ AffiliationData.LomStatusTxt }}
            </v-chip>
          </div>
        </div>
        <div class="status-actions">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small v-bind="attrs" v-on="on" @click="pageData" :loading="LoadingFlag" class="refresh-btn">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>Refresh Status</span>
          </v-tooltip>
        </div>
      </div>

      <!-- Document Section -->
      <div class="document-section">
        <div class="document-header-row">
          <div class="document-label-group">
            <v-icon class="document-icon">mdi-file-document</v-icon>
            <span class="document-label">Affiliation Document</span>
          </div>
        </div>

        <!-- Document Available -->
        <div v-if="AffiliationData.AffiliationDocumentPath != ''" class="document-available">
          <div class="available-icon">
            <v-icon>mdi-check-circle</v-icon>
          </div>
          <div class="available-info">
            <p class="available-text">Document verified and approved</p>
            <v-btn :href="AffiliationData.AffiliationDocumentPath" target="_blank" class="download-btn">
              <v-icon left>mdi-download</v-icon>
              Download Document
            </v-btn>
          </div>
        </div>

        <!-- Request Sent -->
        <div v-else-if="AffiliationData.AffiliationDocumentRequestStatus == 1" class="request-sent">
          <div class="sent-icon">
            <v-icon>mdi-clock-outline</v-icon>
          </div>
          <div class="sent-info">
            <p class="sent-text">Request submitted and pending review</p>
            <small class="sent-subtext">Please wait for approval notification</small>
          </div>
        </div>

        <!-- Request Document -->
        <div v-else class="request-document">
          <div class="request-icon">
            <v-icon>mdi-file-upload</v-icon>
          </div>
          <div class="request-info">
            <p class="request-text">Document not yet requested</p>
            <small class="request-subtext">Send a request to obtain affiliation document</small>
          </div>
          <v-btn class="request-btn" :loading="LoadingFlag" @click.prevent="confirmAlert()">
            <v-icon left>mdi-send</v-icon>
            Send Request
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  props: {
  },
  data() {
    return {
      AffiliationData: "",
      LoadingFlag: true,

      SkeletonLoadingFlag: true,

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
      CurrentYearId: "",
    };
  },
  mounted() { },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = CurrentJciYearId;

        this.pageData();
      }
    },
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "jci_india_lom",
        Action: "list_2",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      this.getAffiliationDocuments();
    },
    getAffiliationDocuments() {
      console.log("getAffiliationDocuments is called");

      this.SkeletonLoadingFlag = true;

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/lom/affiliation-document-list";
      var upload = {
        UserInterface: 1,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var records = "";
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.SkeletonLoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);

          records = response.data.records;
          console.log({ records });

          if (flag == 1) {
            thisIns.AffiliationData = response.data.records;
            console.log("records=" + JSON.stringify(thisIns.AffiliationData));

            // thisIns.toast("success", output);
          } else {
            // thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.SkeletonLoadingFlag = false;
        });
    },
    confirmAlert() {
      console.log("confirmAlert called");

      var htmlTxt = "";
      htmlTxt += "Do you want to Request for Permanent Affiliation Document?";
      Swal.fire({
        title: "Are you sure?",
        text: "",
        icon: "warning",
        html: htmlTxt,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        confirmButtonColor: "#3085d6",
        cancelButtonText: `No`,
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.isConfirmed) {
          this.requestAffiliationDocuments();
        } else {
          this.sweetAlert("error", "You cancelled the process", true);
        }
      });
    },
    requestAffiliationDocuments() {
      console.log("requestAffiliationDocuments is called");

      this.LoadingFlag = true;

      console.log("LoadingFlag" + this.LoadingFlag);

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/lom/request-affiliation-document";
      var upload = {
        UserInterface: 1,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var records = "";
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.LoadingFlag = false;
          console.log("LoadingFlag" + thisIns.LoadingFlag);

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);

          records = response.data.records;
          console.log({ records });

          if (flag == 1) {
            thisIns.sweetAlert("success", output, true);
            thisIns.getAffiliationDocuments();
          } else {
            thisIns.sweetAlert("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.LoadingFlag = false;
        });
    },
  },
  mounted() { },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style lang="scss" scoped>
.affiliation-container {
  width: 100%;

  .affiliation-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .status-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 16px;
    background: linear-gradient(135deg, rgba(86, 189, 163, 0.08) 0%, rgba(0, 151, 215, 0.05) 100%);
    border-radius: 12px;
    border-left: 4px solid #56bda3;
  }

  .status-header {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
  }

  .status-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: #56bda3;
    border-radius: 10px;
    color: white;
    font-size: 20px;
  }

  .status-info {
    flex: 1;
  }

  .status-label {
    font-size: 11px;
    font-weight: 600;
    color: #414042;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 6px;
  }

  .status-chip {
    font-weight: 600 !important;
  }

  .status-actions {
    flex-shrink: 0;
  }

  .refresh-btn {
    background: rgba(86, 189, 163, 0.1) !important;
    color: #56bda3 !important;

    &:hover {
      background: rgba(86, 189, 163, 0.2) !important;
    }
  }

  .document-section {
    padding: 0;
  }

  .document-header-row {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }

  .document-label-group {
    display: flex;
    align-items: center;
    gap: 10px;

    .document-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      background: #56bda3;
      border-radius: 50%;
      color: white;
      font-size: 18px;
    }

    .document-label {
      font-size: 13px;
      font-weight: 700;
      color: #0a0f29;
    }
  }

  .document-available,
  .request-sent,
  .request-document {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px;
    border-radius: 12px;
    border: 2px solid;
  }

  .document-available {
    background: linear-gradient(135deg, #f0fdf4 0%, #e6fffa 100%);
    border-color: #56bda3;

    .available-icon {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 44px;
      background: linear-gradient(135deg, #56bda3 0%, darken(#56bda3, 10%) 100%);
      border-radius: 50%;
      color: white;
      font-size: 24px;
    }

    .available-info {
      flex: 1;

      .available-text {
        font-size: 14px;
        font-weight: 600;
        color: #3a67b1;
        margin: 0 0 8px 0;
      }
    }
  }

  .request-sent {
    background: linear-gradient(135deg, rgba(237, 190, 56, 0.05) 0%, rgba(237, 190, 56, 0.1) 100%);
    border-color: #edbe38;

    .sent-icon {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 44px;
      background: linear-gradient(135deg, #edbe38 0%, darken(#edbe38, 10%) 100%);
      border-radius: 50%;
      color: white;
      font-size: 24px;
    }

    .sent-info {
      flex: 1;

      .sent-text {
        font-size: 14px;
        font-weight: 600;
        color: #3a67b1;
        margin: 0;
      }

      .sent-subtext {
        font-size: 12px;
        color: #414042;
      }
    }
  }

  .request-document {
    background: linear-gradient(135deg, #fff9c4 0%, #fffde7 100%);
    border-color: #edbe38;
    justify-content: space-between;

    .request-icon {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 44px;
      background: linear-gradient(135deg, #edbe38 0%, darken(#edbe38, 5%) 100%);
      border-radius: 50%;
      color: white;
      font-size: 24px;
    }

    .request-info {
      flex: 1;

      .request-text {
        font-size: 14px;
        font-weight: 600;
        color: #3a67b1;
        margin: 0;
      }

      .request-subtext {
        font-size: 12px;
        color: #414042;
      }
    }
  }

  .download-btn,
  .request-btn {
    padding: 10px 16px !important;
    border-radius: 8px !important;
    font-weight: 600 !important;
    transition: all 0.3s ease !important;
    flex-shrink: 0;
  }

  .download-btn {
    background: linear-gradient(135deg, #56bda3 0%, darken(#56bda3, 10%) 100%) !important;
    color: white !important;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(86, 189, 163, 0.3);
    }
  }

  .request-btn {
    background: linear-gradient(135deg, #edbe38 0%, darken(#edbe38, 10%) 100%) !important;
    color: white !important;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(237, 190, 56, 0.3);
    }
  }
}
</style>
